import React, {useState} from "react";
import Typography from "@mui/material/Typography";


import classnames from "classnames";
import Checkbox from "@mui/material/Checkbox";
import {DealModal} from "../../PricingListPage/DealModal";
import {useModalsStore} from "../../../stores/modalsStore";
import {useCRMListDealsContext} from "../../../contexts/CRMListDealsContext";

export const CRMListDealCard = ( { deal, defaultChecked, toggleSelected } ) => {
    const [dealState, setDealState] = useState(deal)
    const openModal = useModalsStore((state) => state.openModal)

    const { onDealSelect } = useCRMListDealsContext()

    const car_detail = dealState.car_detail

    const isLoading = false // updateDealResponse?.loading && dealId() === dealState.id
    const isPurchase = dealState.is_purchase

    return (
        <div
            onClick={() => {
                openModal({
                    element: DealModal,
                    id: "DealModal",
                    props: {
                        id: dealState.id,
                        onSave: (newDealState) => setDealState(newDealState)
                    }
                })
            }}
            className={classnames('ListDealCard', {
                isPurchase: isPurchase
            })}
        >
            <Checkbox
                className={'action-icon'}
                onClick={(e) => {
                    e.stopPropagation()
                    toggleSelected(dealState.id)
                    onDealSelect && onDealSelect(dealState)
                }}
                defaultChecked={defaultChecked}
            />

            <div
                className={'left'}
            >
                <div
                    className={'car-detail'}
                >
                    <Typography
                        sx={{
                            fontSize: '20px',
                            fontWeight: 'bold'
                        }}
                    >
                        {car_detail.year} {car_detail.make} {car_detail.model}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: '14px',
                        }}
                    >
                        {car_detail.trim}
                    </Typography>
                </div>


                <div
                    className={'ListDealCard-lender'}
                >
                    <Typography
                        sx={{
                            fontSize: '14px',
                        }}
                    >
                        {dealState.formatted_quote.lender_name}
                    </Typography>

                </div>

                <label>Description</label>
                <div className={'ListDealCard-description'}>
                    {dealState.description}
                </div>
            </div>
            <div
                className={classnames('right', {
                    // isPurchase: isPurchase
                })}
            >
                <div
                    className={'pay-detail'}
                >
                    <Typography
                        className={classnames('pay-detail_value', {
                            loading: isLoading
                        })}
                        sx={{
                            fontSize: '14px',
                            fontWeight: 'bold',
                            borderBottom: '1px solid white'
                        }}
                    >
                        { isPurchase ? 'PURCHASE' : 'LEASE'}
                    </Typography>
                    <Typography
                        className={classnames('pay-detail_value', {
                            loading: isLoading
                        })}
                        sx={{
                            fontSize: '14px',
                            fontWeight: 'bold'
                        }}
                    >
                        ${dealState.formatted_quote.amount_due_at_signing}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: '10px',
                        }}
                    >
                        Due at Signing
                    </Typography>

                    <Typography
                        className={classnames('pay-detail_value', {
                            loading: isLoading
                        })}
                        sx={{
                            fontSize: '14px',
                            fontWeight: 'bold'
                        }}
                    >
                        ${dealState.formatted_quote.monthly_payment}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: '10px',
                        }}
                    >
                        Per Month
                    </Typography>
                    <Typography
                        className={classnames('pay-detail_value', {
                            loading: isLoading
                        })}
                        sx={{
                            fontSize: '14px',
                            fontWeight: 'bold'
                        }}
                    >
                        {dealState.term}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: '10px',
                        }}
                    >
                        Months
                    </Typography>
                    <Typography
                        className={classnames('pay-detail_value', {
                            loading: isLoading
                        })}
                        sx={{
                            fontSize: '14px',
                            fontWeight: 'bold'
                        }}
                    >
                        {dealState.mileage}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: '10px',
                        }}
                    >
                        Miles
                    </Typography>
                    <Typography
                        className={classnames('pay-detail_value', {
                            loading: isLoading
                        })}
                        sx={{
                            fontSize: '14px',
                            fontWeight: 'bold',
                        }}
                    >
                        ${dealState.profit}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: '10px',
                        }}
                    >
                        Profit
                    </Typography>
                </div>
            </div>
        </div>
    )
}